/**
 * @file Maps each route to the permissions required to reach it, all of them.
 *
 * What the page cannot function without, not everything it touches: optional
 * parts hide themselves, and alternatives are not requirements -- properties
 * reads whichever asset type is selected, so listing all three would refuse
 * someone who holds one.
 */

import type { Permission } from "@/gql/graphql";

export const routePermissions: Record<Route, readonly Permission[]> = {
  "/": ["ASSET_READ"],
  "/home": ["ASSET_READ"],
  "/home/properties": ["PILE_PROPERTY_READ"],
  "/home/inspections": ["PILE_INSPECTION_READ"],
  "/home/notes": ["NOTE_READ"],
  "/assets-table": ["ASSET_READ"],
  "/all-notes": ["NOTE_READ"],
  "/batch-entry": ["ASSET_READ"],
  "/manage-assets": ["ASSET_READ", "ASSET_WRITE"],
  "/metrics": ["METRIC_READ"],
  "/configuration": ["INSPECTION_FREQUENCY_READ"],
  "/configuration/default-properties": ["PILE_DEFAULT_PROPERTY_READ"],
  "/configuration/loads": ["PILE_LOAD_READ"],
  "/configuration/inspection-timeline": ["INSPECTION_FREQUENCY_READ"],
  "/manage-access": ["USER_READ", "USER_WRITE"],
  "/configuration/custom-fields": ["CUSTOM_FIELD_READ", "CUSTOM_FIELD_WRITE"],
};

export type Route =
  | "/manage-assets"
  | "/home"
  | "/"
  | "/assets-table"
  | "/all-notes"
  | "/metrics"
  | "/configuration"
  | "/manage-access"
  | "/home/properties"
  | "/home/inspections"
  | "/home/notes"
  | "/batch-entry"
  | "/configuration/default-properties"
  | "/configuration/loads"
  | "/configuration/inspection-timeline"
  | "/configuration/custom-fields";
